// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-content-header {
  margin-top: -25px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pages/about-kaupsagan/about-kaupsagan.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF","sourcesContent":[".main-content-header {\r\n  margin-top: -25px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
